import { useContext } from 'react';
import { ColorThemeContext, Colors } from '@shared/styles';
import { MBButtonTheme } from './mbButtonTypes';

export function useBackgroundColor(theme: MBButtonTheme, disabled: boolean): string {
  const colors = useContext(ColorThemeContext);
  if (theme === 'transparent') {
    return 'transparent';
  }

  if (disabled) {
    return 'white';
  }

  if (theme === 'outline') {
    return colors.button.backgroundInverted;
  }

  if (theme === 'tertiary') {
    return colors.button.tertiary;
  }

  return colors.button.background;
}

export function useBorderColor(theme: MBButtonTheme, disabled: boolean): string {
  const colors = useContext(ColorThemeContext);
  if (disabled && theme !== 'transparent') {
    return Colors.v2.gray10;
  }

  if (theme === 'outline') {
    return colors.button.foregroundInverted;
  }

  return 'transparent';
}

export function useForegroundColor(theme: MBButtonTheme, disabled: boolean): string {
  const colors = useContext(ColorThemeContext);
  if (disabled) {
    return Colors.v2.gray30;
  }

  if (theme === 'outline' || theme === 'transparent') {
    return colors.button.foregroundInverted;
  }

  if (theme === 'tertiary') {
    return colors.foregroundActive;
  }

  return colors.button.foreground;
}
